import { MAP_TEXT_SEARCH_CAPABILITY } from '@ooh/contracts';
import { useContextQuery } from '../../../hooks/use-context-query';

/**
 * Returns true only when the map text-search feature flag is explicitly enabled.
 *
 * FAIL-CLOSED: returns false while the me-context is loading and false whenever
 * the capability is absent. When OFF (the default), the map search bar delegates
 * all non-coordinate input to the geocoder instead of running a media-unit
 * text query against the pins endpoint.
 */
export function useMapTextSearchEnabled(): boolean {
  const { data } = useContextQuery();
  return data?.capabilities.includes(MAP_TEXT_SEARCH_CAPABILITY) === true;
}
